var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcnTemperature = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.238,329.726c0-8.99,0-247.983,0-259.981C357.238,31.287,325.949,0,287.492,0c-38.45,0-69.732,31.287-69.732,69.744 c0,13.057,0,251.358,0,259.981C146.628,393.683,192.014,512,287.493,512C382.932,512,428.371,393.692,357.238,329.726z  M319.775,228.964h-64.551V69.744c0-17.8,14.476-32.281,32.268-32.281c17.8,0,32.282,14.481,32.282,32.281V228.964z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.232,237.268h-31.484c-10.345,0-18.732,8.387-18.732,18.732c0,10.345,8.387,18.732,18.732,18.732h31.484 c10.345,0,18.732-8.387,18.732-18.732C188.963,245.655,180.576,237.268,170.232,237.268z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.232,175.566h-31.484c-10.345,0-18.732,8.387-18.732,18.732c0,10.345,8.387,18.732,18.732,18.732h31.484 c10.345,0,18.732-8.387,18.732-18.732C188.963,183.953,180.576,175.566,170.232,175.566z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M170.232,113.864h-31.484c-10.345,0-18.732,8.387-18.732,18.732s8.387,18.732,18.732,18.732h31.484 c10.345,0,18.732-8.387,18.732-18.732S180.576,113.864,170.232,113.864z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcnTemperature, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icn-temperature.45b0eae6.svg";
export { ForwardRef as ReactComponent };